(function () {
    "use strict";

    function syncStickyButtonState(addToCartButton, stickyAtcButton) {
        const buyNowButton = document.querySelector('.buy-now-form .btn');

        const isSoldOut =
            addToCartButton.disabled ||
            addToCartButton.classList.contains('sold-out') ||
            addToCartButton.value === 'sold_out' ||
            addToCartButton.textContent.trim().toLowerCase().includes('sold out');

        if (isSoldOut) {
            // Sold Out button
            stickyAtcButton.disabled = true;
            stickyAtcButton.textContent = 'Sold Out';
            stickyAtcButton.classList.add('convx__sticky-atc-button--sold-out');

            // Hide Buy Now
            if (buyNowButton) {
                buyNowButton.style.display = 'none';
            }
        } else {
            // Restore ATC button
            stickyAtcButton.disabled = false;
            stickyAtcButton.textContent = 'Add to Cart';
            stickyAtcButton.classList.remove('convx__sticky-atc-button--sold-out');

            // Restore Buy Now
            if (buyNowButton) {
                buyNowButton.style.display = '';
            }
        }
    }

    function showBuyNowButton() {
        let buyNowButtons = [];
        let stickyAtcButton = null;
        let addToCartButton = null;
        let stickyPanel = null;

        buyNowButtons = document.querySelectorAll('.buy-now-form');
        stickyAtcButton = document.querySelector('.convx__sticky-atc-button');
        addToCartButton = document.querySelector('.product-info__add-to-cart button[type="submit"]');
        stickyPanel = document.querySelector('.convx__sticky-atc-panel');

        console.log("buyNowButtons: ", buyNowButtons);
        console.log("stickyAtcButton: ", stickyAtcButton);
        console.log("addToCartButton: ", addToCartButton);
        console.log("stickyPanel: ", stickyPanel);

        // Change button type to submit
        buyNowButtons.forEach(form => {
            const button = form.querySelector('.btn');
            if (button) {
                button.type = 'submit';
            }
        });

        // Guard: both elements must exist before proceeding
        if (!stickyAtcButton || !addToCartButton) return;

        // Sync initial state immediately
        syncStickyButtonState(addToCartButton, stickyAtcButton);

        // Watch for DOM changes on the main ATC button (Shopify swaps text/disabled on variant change)
        const mutationObserver = new MutationObserver(() => {
            syncStickyButtonState(addToCartButton, stickyAtcButton);
        });
        mutationObserver.observe(addToCartButton, {
            attributes: true,          // catches disabled attr changes
            childList: true,           // catches text node swaps
            subtree: true,             // catches nested span text (common in Shopify themes)
            characterData: true,
        });

        // Delegate click to main ATC button only when not sold out
        stickyAtcButton.addEventListener('click', function (event) {
            event.preventDefault();
            if (!stickyAtcButton.disabled) {
                addToCartButton.click();
            }
        });

        // Sticky panel visibility logic
        if (!stickyPanel) return;

        const hideOnButtonVisible = stickyPanel.hasAttribute('data-hide-on-button-visible');
        if (!hideOnButtonVisible) {
            stickyPanel.classList.remove('hide');
            stickyPanel.classList.add('show');
            return;
        }

        const intersectionObserver = new IntersectionObserver(
            ([entry]) => {
                if (entry.isIntersecting) {
                    stickyPanel.classList.remove('show');
                    stickyPanel.classList.add('hide');
                } else {
                    stickyPanel.classList.remove('hide');
                    stickyPanel.classList.add('show');
                }
            },
            { root: null, threshold: 0 }
        );

        stickyPanel.classList.add('hide');
        intersectionObserver.observe(addToCartButton);
    }

    function onDOMContentLoaded() {
        const path = location.pathname;
        const isProducts = path.includes("/products");

        if (isProducts) {
            showBuyNowButton();
        }
    }

    if (document.readyState === "loading") {
        document.addEventListener("DOMContentLoaded", onDOMContentLoaded, { once: true });
    } else {
        onDOMContentLoaded();
    }
})();